import { createSelector } from "reselect";

// Input selector to get the entire state
const getDataState = (state) => state;

// General selector for sections based on layout
// const getSectionByLayout = (state, layout) => {
//   const section = state?.data?.data?.[state.region?.region]?.en?.sections?.find((section) => section.layout === layout);
//   return section || null;
// };

// Selector for loading state
export const getLoadingState = (key) =>
  createSelector([getDataState], (state) => state.loading?.[key] || false);

// Selector for error state
export const getError = (key) =>
  createSelector([getDataState], (state) => state.error?.[key] || null);

// Selector for general data
export const getData = (key) =>
  createSelector([getDataState], (state) => {
    //console.log("State Data:", state.data.data?.landing?.en); // Log the entire data object
    return state.data?.data?.[key] || null;
  });

// Banner component selector
export const bannerone = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "hero_area"
      )?.attributes?.hero_area_images || []
  );

// Feature component selector
export const featureone = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "feature_one"
      )?.attributes?.feature_one_images || []
  );

// Promotional component selector
export const promotionalone = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "promotional_one"
      )?.attributes?.promotional_one_images || []
  );

// flash sale selector
export const flashone = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "flash_sales"
      )?.attributes?.flash_sales || []
  );
export const flashonetitle = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "flash_sales"
      )?.attributes || []
  );

// Flash sale component selector
export const flashsaleone = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "serving_industries_banners"
      )?.attributes?.serving_industries || []
  );

// Product list component selector
export const productlistone = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "featured_products"
      )?.attributes?.featuredproducts || []
  );

export const product_listone_title = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "featured_products"
      )?.attributes?.title || []
  );

// Offer component selector
export const offerone = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "offer_one"
      )?.attributes?.offer_one || []
  );

// newarrivals component selector
export const newarrivals = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "new_arrivals"
      )?.attributes?.new_arrivals || []
  );

// Shipping component selector
export const shipping = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "become_customer"
      )?.attributes?.content || []
  );

// Newsletter component selector
export const newsletter = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "testimonial"
      )?.attributes?.testimonials || []
  );

// Brand deals component selector
export const brand_deals = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "brand_deals"
      )?.attributes?.deals || []
  );

export const brand_deals_title = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "brand_deals"
      )?.attributes?.title || ""
  );

// Brand deals component selector
export const organic_food = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "organic_food"
      )?.attributes?.organicfood || []
  );
export const organic_food_title = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "organic_food"
      )?.attributes?.title || ""
  );

// Recommended component selector
export const recommended = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "highlighted_specials"
      )?.attributes?.highlighted_specials || []
  );

export const recommended_title = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "highlighted_specials"
      )?.attributes?.title || ""
  );

export const categoriesarea = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "categories_area"
      )?.attributes?.categories || []
  );

export const categoriesareatitle = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "categories_area"
      )?.attributes || []
  );

export const hotdealsone = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "hot_deals"
      )?.attributes?.hotdeals || []
  );

export const hotdealscontent = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "hot_deals"
      )?.attributes || {}
  );

export const newsletterone = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "news_letter_one"
      )?.attributes || []
  );

export const deliveryone = (key) =>
  createSelector(
    [getDataState],
    (state) =>
      state.data?.data?.[key]?.en?.sections?.find(
        (section) => section.layout === "delivery_one"
      )?.attributes?.delivery_one || []
  );

// About Us component selector
export const aboutus = (key) =>
  createSelector([getDataState], (state) => state.data?.data?.[key] || null);

// Our Story component selector
export const our_story = (key) =>
  createSelector(
    [getDataState],
    (state) => state.data?.data?.[key]?.en || null
); 

// Our Story component selector
export const contact_us_data = (key) =>
    createSelector(
      [getDataState],
      (state) => state.data?.data?.[key] || null
); 

export const contact_us = (key, name = "contact_us") =>
  createSelector(
    [getDataState],
    (state) => state.data?.data?.[key]?.[name]?.en || null
);

export const our_brands = (key) =>
  createSelector(
    [getDataState],
    (state) => state.data?.data?.[key]?.en || null
);
